import { createFileRoute } from '@tanstack/react-router';

import { PlatformActivityLogPage } from '@/features/evidence-logs';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/evidence/logs')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.platformActivityLog'),
  }),
  component: EvidenceLogsRoute,
});

function EvidenceLogsRoute() {
  return <PlatformActivityLogPage />;
}
